// extracted by mini-css-extract-plugin
export default {"formGroup":"g5Mi986oFoSqePaFHiyL","checkbox":"jtIHolLn7l4Ye0_znSuI","reasonInput":"cx65b8wAUZSJJdAwgUDg"};